<div
  #wrapper
  class="iu-input-translations-ui"
  [pTooltip]="tooltip"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  [style.width]="overridedCSS?.width"
  [tooltipOptions]="TOOLTIP_OPTIONS">
  @if (isLabelDisplay && !!label?.trim()) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }

  <span
    [attr.data-enabled]="true"
    [attr.data-focus]="open()"
    [attr.data-readonly]="isReadOnly"
    [ngClass]="[hasConflict ? 'iu-field-conflict-text' : '', mandatoryCss, 'ui-corner-all input-field p-inputtext']"
    (click)="onClick($event, input)"
    (contextmenu)="onContextMenu($event)"
    (focus)="input.focus()"
    (keydown.altgr)="onContextMenu($any($event))"
    (press)="onContextMenu($any($event))">
    <input
      #input
      autocomplete="off"
      data-cy="input-translations"
      [attr.data-cy-columnName]="data ? data.columnName : columnName"
      [id]="uuid"
      [placeholder]="placeHolder ?? ''"
      [readonly]="isReadOnly"
      [style.font-size]="overridedCSS?.inputFontSize"
      [style.height]="overridedCSS?.inputHeight"
      [tabindex]="isReadOnly ? '-1' : null"
      [type]="data ? data.fieldType : 'text'"
      [value]="visibleValue()"
      (change)="onValueChange($event, defaultLang())"
      (focus)="toggle(true)"
      (input)="onUserInput($any($event))"
      (keyup)="onKeyUp($event)"
      (mousedown)="$event.preventDefault()" />

    <iu-dropdown class="input-translations-dropdown" [linkedTo]="[wrapper]" [(open)]="open">
      <div class="input-translations-dropdown-content">
        <div class="active-translations-title">
          <!-- TODO: translate -->
          <span class="label">{{ 'Active language translation:' | translate }}</span>
          <span class="value">{{ defaultLang() }}</span>
        </div>

        @if (showTranslationsSection()) {
          <div class="other-translations-title">
            <i aria-hidden="true" class="fa-solid fa-globe"></i>
            <!-- TODO: translate -->
            <span>{{ 'Translations' | translate }}</span>
          </div>

          <ul class="input-translations-list">
            @for (language of otherValues() | keyvalue; track $index) {
              @if (language.key !== defaultLang()) {
                <li class="input-translations-item">
                  <select (change)="onKeyChange(language, $event)">
                    <option selected [value]="language.key">{{ language.key }}</option>

                    @for (key of options(); track $index) {
                      <option value="{{ key }}">{{ key }}</option>
                    }
                  </select>

                  <input
                    class="ui-corner-all input-field p-inputtext"
                    type="text"
                    id="language-{{ language.key }}"
                    [value]="language.value"
                    (change)="onValueChange($event, language.key)" />

                  <button class="input-translations-list-btn" type="button" (click)="deleteEntry(language.key)">
                    <i aria-hidden="true" class="icon-delete"></i>
                  </button>
                </li>
              }
            }

            <li
              class="input-translations-item input-translations-item-add"
              [ngStyle]="{ display: options()?.length > 0 ? '' : 'none' }">
              <button type="button" (click)="addEntry()">
                <i aria-hidden="true" class="icon-add-square"></i>
                <!-- TODO: translate -->
                <span>{{ 'Add new entry' | translate }}</span>
              </button>
            </li>
          </ul>
        }
      </div>
    </iu-dropdown>
  </span>

  @if (hasConflict && dataStored) {
    <i
      #spanInput
      role="button"
      tabindex="0"
      [attr.title]="opConflict.iconTooltip"
      [attr.aria-label]="opConflict.iconTooltip"
      class="rtconflict fas fa-exclamation-triangle iconClass"
      (click)="showConflictPanel($event)"
      (keydown.enter)="showConflictPanel($event)"
      (keydown.space)="showConflictPanel($event)"></i>
  }

  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="value()"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</div>
<iu-dropdown />

<iu-field-conflict-panel #opConflict [field]="this" />
